import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useRef } from 'react';
import Badge from '../../deprecated/badge/index.js';
import { Loader } from '../../loader/index.js';
import { Dialog } from './Dialog.js';
import { DialogContent } from './DialogContent.js';
import { DialogHeader } from './DialogHeader.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { CardFooter } from '../../v2/dataDisplay/Card/CardFooter.js';
import { Button } from '../../v2/navigation/buttons/Button/Button.js';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function ConfirmDialog(props) {
  var _props$appearance = props.appearance,
    appearance = _props$appearance === void 0 ? 'primary' : _props$appearance,
    _props$badgeSize = props.badgeSize,
    badgeSize = _props$badgeSize === void 0 ? 'medium' : _props$badgeSize,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    confirm = props.confirm,
    cancel = props.cancel,
    onConfirm = props.onConfirm,
    onCancel = props.onCancel,
    children = props.children,
    heading = props.heading,
    glyph = props.glyph,
    media = props.media,
    restProps = __rest(props, ["appearance", "badgeSize", "loading", "disabled", "confirm", "cancel", "onConfirm", "onCancel", "children", "heading", "glyph", "media"]);
  var initialFocusRef = useRef(null);
  function getMedia() {
    if (media) {
      return media;
    }
    return glyph ? /*#__PURE__*/jsx(Badge, {
      glyph: glyph,
      size: badgeSize,
      appearance: appearance
    }) : undefined;
  }
  return /*#__PURE__*/jsxs(Dialog, _extends({
    initialFocusRef: initialFocusRef
  }, restProps, {
    children: [(heading || glyph || media) && /*#__PURE__*/jsx(DialogHeader, {
      title: heading,
      media: getMedia()
    }), /*#__PURE__*/jsx(DialogContent, {
      children: children
    }), /*#__PURE__*/jsxs(CardFooter, {
      children: [/*#__PURE__*/jsx(Button, {
        ref: initialFocusRef,
        type: "button",
        appearance: "secondary",
        disabled: loading,
        onClick: onCancel,
        children: cancel
      }), /*#__PURE__*/jsxs(Button, {
        disabled: loading || disabled,
        type: "button",
        appearance: appearance,
        onClick: onConfirm,
        children: [confirm, loading && /*#__PURE__*/jsx(Loader, {})]
      })]
    })]
  }));
}

export { ConfirmDialog };
